module.exports = __webpack_public_path__ + "static/5-Kaip-vyks-egzaminas-170cd495ab80b6b5fa16c3b0e7d8009e.svg";